import { Box } from "@mui/material";
import UsersHeader from "./UsersHeader";
import { useAppSelector } from "../../Redux/hooks";
import UsersUrlLoader from "./UsersUrlLoader";
import UsersUrlSetter from "./UsersUrlSetter";
import { useState } from "react";
import { permissions } from "../../utils/roles";
import UsersTable from "./UsersTable";
import { dataTablePageShell } from "../../utils/dataTableShell";

const Users = () => {
  const urlLoaded = useAppSelector((state) => state.administrators);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  const [canEdit] = useState(
    studyPermissions.includes(permissions.userManagement) && dataEditable
  );
  return urlLoaded ? (
    <>
      <UsersHeader canEdit={canEdit} />
      <Box sx={{ ...dataTablePageShell("calc(100vh - 144px)"), p: 2.5 }}>
        <UsersTable canEdit={canEdit} />
      </Box>
      <UsersUrlSetter />
    </>
  ) : (
    <UsersUrlLoader />
  );
};

export default Users;
